export const authHeader = 'Authorization';
export const sessionHeader = 'Session-Id';
